<template>
  <div class="admin-dash">
    <label class="admin-dash__hide-completed">
      <input type="checkbox" v-model="showCompleted"/>
      Show Completions
    </label>

    <ul class="admin-dash__clients" v-if="clients.length">
      <li
        v-for="client in clients"
        :key="client.uid"
        class="admin-dash__clients__client"
        :class="{
          'action-required': getStepOwner(client.timelineStep) === 'admin' && client.timelineStep < totalSteps,
          'completed': client.timelineStep === totalSteps
        }"
        v-show="showCompleted ? client.timelineStep === totalSteps : client.timelineStep < totalSteps"
        >
        <!-- Name -->
        <h4>{{ client.firstName }} {{ client.lastName }}</h4>
        <!-- Email -->
        <p>{{ client.email }}</p>
        <!-- Package -->
        <h6 v-if="client.package" v-html="'Package: ' + client.package.charAt(0).toUpperCase() + client.package.slice(1)"/>
        <br/>
        <!-- Status -->
        <h6 v-html="'Status: ' + statusText(client)"/>
        <ul class="admin-dash__clients__client__actions">
          <li class="admin-dash__clients__client__actions__action"><router-link :to="`/dashboard?uid=${client.uid}`" v-html="'Timeline'"/></li>
          <li class="admin-dash__clients__client__actions__action"><router-link :to="`/documents?uid=${client.uid}`" v-html="'Docs'"/></li>
          <li class="admin-dash__clients__client__actions__action"><router-link :to="`/update-profile?uid=${client.uid}`" v-html="'Profile'"/></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import * as fb from '@/library/firebase'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'AdminDashboard',
  data() {
    return {
      clients: [],
      showCompleted: false
    }
  },
  computed: {
    ...mapGetters([
      'getStepOwner',
      'totalSteps'
    ]),
    ...mapState([
      'isAdmin',
      'userProfile'
    ]),
  },
  async mounted() {
    this.loadPDFURL()
    if (this.userProfile && this.isAdmin) {
      this.clients = await this.getClients()
    }
  },
  methods: {
    ...mapActions([
      'getClients'
    ]),
    loadPDFURL() {
      if (!this.pdfSrc && this.currentUserProfile?.application?.asFiled) {
        const storageRef = fb.storage.ref()
        const fileRef = storageRef.child(`docs/${this.currentUserProfile.uid}/${this.currentUserProfile.application.asFiled}`)
        fileRef.getDownloadURL().then(url => {
          if (url) {
            this.pdfSrc = url
          }
        })
      }
    },
    statusText(client) {
      if (client.timelineStep === null) {
        return 'Not Started'
      }
      else if (client.timelineStep === this.totalSteps) {
        return 'Completed'
      }
      else if (client.timelineStep < this.totalSteps && this.getStepOwner(client.timelineStep) === 'admin') {
        return 'Action Required';
      }
      else {
        return 'Awaiting Client';
      }
    }
  },
  watch: {
    async userProfile(val) {
      if (val) {
        this.clients = await this.getClients()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-dash {
  padding: 40px;
  position: relative;

  &__hide-completed {
    position: absolute;
    top: 10px;
    right: 20px;
  }
  &__clients {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    &__client {
      list-style: none;
      border: solid 1px #ccc;
      padding: 20px 40px;
      margin: 0 20px 20px 0;
      flex-basis: calc(25% - 20px);
      min-width: 260px;
      @media($sm-down) {
        flex-basis: calc(50% - 10px);
      }
      &:last-child {
        margin-right: 0;
      }
      &.action-required {
        background-color: #FFF;
        position: relative;
      }

      h4 {
        font-size: 22px;
      }
      h6 {
        margin: 0;
        font-weight: normal;
      }
      a {
        font-size: 12px;
      }

      &__actions {
        margin-top: 20px;
        &__action {
          list-style: none;
          display: inline-block;
          padding: 0 10px;
        }
      }
    }
  }
}
</style>